<template>
  <section>
    <h4>攝影剪輯後製正職人員</h4>
    <h5>工作內容：</h5>
    <p>
      本會現場講堂及教室課程攝影。<br>
      支援本會園區活動攝影。<br>
      課程攝影後製剪接製作。
    </p>
    <h5>我們所需的基礎條件為：</h5>
    <p>
      正信佛教徒、待人有耐心、處事能積極，願將專長貢獻於 佛教，造福學佛大眾者。<br>
      具基本攝影概念及相關操作經驗。<br>
      具後製剪接之概念及相關操作經驗。<br>
      無經驗，願接受培訓學習攝影及後製剪接能力者亦可。
    </p>
    <h5>應徵方式：</h5>
    <p>
      履歷表(<a href="https://www2.budaedu.org/official-website-data/recruitment/application-form-it-unit.doc" target="_blank">下載</a>)請email至<a href="mailto:mis@budaedu.org">mis@budaedu.org</a>或交至本會3樓。<br>
      或以信函寄至本會「台北市杭州南路一段 55 號 8 樓 之1／資訊組收」<br>
      (未來若有任何職缺異動情形，請自行參考網頁。恕不另行通知。)
    </p>
    <p>
      財團法人佛陀教育基金會 資訊組 合十<br>
      TEL：<a href="tel:+886-2-23951198">{{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198</a>轉分機38<br>
      FAX：02-23913415
    </p>
  </section>
</template>
<script>
import Vue from 'vue'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: "post-production-staff",
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>